import { usePermanentRealtimeDealers } from "components/DealersAndLocationsDropdown/hooks";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";

import type { Appointment } from "models";

export const useAppointmentDealer = (appointment?: Appointment) => {
  const { dealers } = usePermanentRealtimeDealers();
  const appointmentLocation = useAppointmentLocation(appointment);

  if (!appointmentLocation) return;

  return dealers.find(dealer => dealer.id === appointmentLocation.dealer_id);
};
